import {
  Companion_instancet9lyvx4dyg0w as Companion_instance,
  Issue1fn0d1tovjb9y as Issue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareIssueFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Issue_raised_getInstance(), Issue_resolved_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function Issue_raised$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function Issue_raised$_get_name_$ref_b365h1() {
  return (p0) => p0.k20();
}
function Issue_raised$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Issue_raised$_get_serializer_$ref_icwtde() {
  return (p0) => p0.j2j();
}
function Issue_raised$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function Issue_raised$_get_annotations_$ref_gz1x8q() {
  return (p0) => p0.bz();
}
var Issue_raisedClass;
function Issue_raised() {
  if (Issue_raisedClass === VOID) {
    class $ {
      constructor() {
        Issue_raised_instance = this;
        var tmp = this;
        tmp.e6a_1 = lazy(Issue_raised$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f6a_1 = lazy(Issue_raised$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g6a_1 = lazy(Issue_raised$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Issue_raised$_get_name_$ref_b365h1(), null);
        return tmp0.f2();
      }
      h6a(receiver) {
        return receiver.i6a_1;
      }
      m2j(receiver) {
        return this.h6a(receiver instanceof Issue() ? receiver : THROW_CCE());
      }
      k6a(receiver, value) {
        return receiver.l6a(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Issue() ? receiver : THROW_CCE();
        return this.k6a(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Issue_raised$_get_serializer_$ref_icwtde(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Issue_raised$_get_annotations_$ref_gz1x8q(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Issue_raised', VOID, VOID, [SerializableProperty()]);
    Issue_raisedClass = $;
  }
  return Issue_raisedClass;
}
var Issue_raised_instance;
function Issue_raised_getInstance() {
  if (Issue_raised_instance === VOID)
    new (Issue_raised())();
  return Issue_raised_instance;
}
function Issue_resolved$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(1);
}
function Issue_resolved$_get_name_$ref_39j63() {
  return (p0) => p0.k20();
}
function Issue_resolved$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Issue_resolved$_get_serializer_$ref_s2b19u() {
  return (p0) => p0.j2j();
}
function Issue_resolved$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(1);
}
function Issue_resolved$_get_annotations_$ref_xpuia2() {
  return (p0) => p0.bz();
}
var Issue_resolvedClass;
function Issue_resolved() {
  if (Issue_resolvedClass === VOID) {
    class $ {
      constructor() {
        Issue_resolved_instance = this;
        var tmp = this;
        tmp.m6a_1 = lazy(Issue_resolved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6a_1 = lazy(Issue_resolved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6a_1 = lazy(Issue_resolved$annotations$delegate$lambda);
        this.p6a_1 = null;
        this.q6a_1 = 'null';
      }
      k20() {
        var tmp0 = this.m6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Issue_resolved$_get_name_$ref_39j63(), null);
        return tmp0.f2();
      }
      h6a(receiver) {
        return receiver.j6a_1;
      }
      m2j(receiver) {
        return this.h6a(receiver instanceof Issue() ? receiver : THROW_CCE());
      }
      r6a(receiver, value) {
        return receiver.l6a(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Issue() ? receiver : THROW_CCE();
        return this.r6a(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Issue_resolved$_get_serializer_$ref_s2b19u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Issue_resolved$_get_annotations_$ref_xpuia2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Issue_resolved', VOID, VOID, [SerializableProperty()]);
    Issue_resolvedClass = $;
  }
  return Issue_resolvedClass;
}
var Issue_resolved_instance;
function Issue_resolved_getInstance() {
  if (Issue_resolved_instance === VOID)
    new (Issue_resolved())();
  return Issue_resolved_instance;
}
//region block: exports
export {
  prepareIssueFields as prepareIssueFieldsfnt334grlgm6,
};
//endregion

//# sourceMappingURL=IssueFields.mjs.map
